import { render, staticRenderFns } from "./FooterSingleItem.vue?vue&type=template&id=b3c2a904"
import script from "./FooterSingleItem.vue?vue&type=script&lang=ts"
export * from "./FooterSingleItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports